/**
 * Created by antonio on 12/02/15.
 */
define('payment/templates/payment-controller',['all/comeon', 'payment/templates/form-template', 'payment/templates/deposit-sender', 'payment/templates/deposit-renderer', 'payment/templates/withdraw-sender', 'payment/templates/withdraw-renderer'], function (comeon, formTemplate, depositSender, depositRenderer, withdrawSender, withdrawRenderer) {
	'use strict';

	function createControllerData(paymentType, data) {
		var controllerData = {
			formTemplates: [],
			formTemplateTypes: [],
			isFirstDeposit: undefined,
			playerCurrency: undefined,
			selectedFormMethodId: undefined,
			selectedCurrency: undefined,
			selectedAmount: undefined,
			sender: undefined,
			renderer: undefined
		};

		data.formTemplateTypes.forEach(function (formTemplateData) {
			controllerData.formTemplateTypes[formTemplateData.formTemplateCode] = formTemplateData;
		});
		controllerData.playerCurrency = data.playerCurrency;
		if (data.lastUsedMethodDetails !== undefined) {
			controllerData.selectedFormMethodId = data.lastUsedMethodDetails.lastPaymentMethodId;
			controllerData.selectedCurrency = data.lastUsedMethodDetails.lastCurrency;
			if(data.lastUsedMethodDetails.lastAmount !== undefined){
				controllerData.selectedAmount = data.lastUsedMethodDetails.lastAmount;
			}
			controllerData.isFirstDeposit = data.lastUsedMethodDetails.isFirstDeposit;
		} else {
			controllerData.selectedFormMethodId = data.paymentMethods[0].methodId;
			controllerData.selectedCurrency = controllerData.playerCurrency;
			controllerData.isFirstDeposit = false;
		}


		controllerData.sender = senders[paymentType];
		controllerData.renderer = renderers[paymentType];

		setupFormTemplates(data, controllerData);

		return controllerData;
	}

	function setupFormTemplates(data, controllerData) {
		data.paymentMethods.forEach(function (paymentMethodData) {
			controllerData.formTemplates.push(formTemplate.create(paymentMethodData));
		});
	}

	var senders = {
			DEPOSIT: depositSender,
			WITHDRAW: withdrawSender
		},
		renderers = {
			DEPOSIT: depositRenderer,
			WITHDRAW: withdrawRenderer
		};

	return {
		create: function (paymentType, data) {
			return comeon.create(this.api, createControllerData(paymentType, data));
		},
		api: {
			getSelectedFormTemplate: function () {
				for (var i = 0; i < this.formTemplates.length; i++) {
					if (this.formTemplates[i].paymentMethod.methodId === this.selectedFormMethodId) {
						return this.formTemplates[i];
					}
				}
			},
			initSelectedFormTemplate: function (initPromise) {
				var selectedFormTemplate = this.getSelectedFormTemplate();
				selectedFormTemplate.init(this, initPromise);
			},
			renderSelectedFormTemplate: function (paymentsInstance) {
				var selectedFormTemplate = this.getSelectedFormTemplate();
				selectedFormTemplate.render(this, paymentsInstance);
			},
			sendPayment: function (paymentsInstance) {
				var selectedFormTemplate = this.getSelectedFormTemplate();
				selectedFormTemplate.send(this, paymentsInstance);
			}
		}
	};
});

